import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Students from './pages/Students';
import Parents from './pages/Parents';
import Fees from './pages/Fees';
import Reports from './pages/Reports';
import Attendance from './pages/Attendance';

function ProtectedRoute({ children }) {

  const isLoggedIn = localStorage.getItem('isLoggedIn');

  return isLoggedIn
    ? children
    : <Navigate to="/login" />;
}

function App() {

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route path="/" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />

        <Route path="/students" element={
          <ProtectedRoute>
            <Students />
          </ProtectedRoute>
        } />

        <Route path="/parents" element={
          <ProtectedRoute>
            <Parents />
          </ProtectedRoute>
        } />

        <Route path="/fees" element={
          <ProtectedRoute>
            <Fees />
          </ProtectedRoute>
        } />

        <Route path="/attendance" element={
          <ProtectedRoute>
            <Attendance />
          </ProtectedRoute>
        } />

        <Route path="/reports" element={
          <ProtectedRoute>
            <Reports />
          </ProtectedRoute>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;